<template>
<div class="lib-tabs">
    <div class="lib-tab"
         v-for="(tab, index) in tabs"
         :class="{_selected: index === value, _shrinkable: tab.shrinkable}"
         @click="$emit('input', index)">
        <template v-if="tab.suffix && tab.shrinkable">
            <span class="lib-tab-shrink">{{tab.shrinkable}}&nbsp;</span> <span>{{tab.suffix}}</span>
        </template>
        <template v-else>
            {{tab}}
        </template>
    </div>
</div>
</template>

<script>
export default {
    name: "LibTabs",
    props: ['tabs', 'value'],
}
</script>

<style scoped lang="scss">
@import "../../styles/prelude";

.lib-tabs {
    display: flex;
    min-width: 0;

    .lib-tab {
        text-align: center;
        flex-grow: 1;
        color: $gray;
        font-size: 14px;
        letter-spacing: 2.1px;
        font-weight: 900;
        text-transform: uppercase;
        padding: 10px 15px;
        white-space: nowrap;

        &._shrinkable {
            flex-shrink: 1;
            display: flex;
            justify-content: center;
            min-width: 0;

            .lib-tab-shrink {
                overflow: hidden;
                text-overflow: ellipsis;
            }
        }

        &._selected {
            color: $blue;
            border-bottom: 2px solid $blue;
        }

        &:hover {
            color: $blue;
            cursor: pointer;
        }
    }
}
</style>